
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import ActionsDropdown from "../ActionsDropdown";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Dailytask() {
  const [responseData, setResponseData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [isPreviewshowModal, setPreviewShowModal] = useState(false);
  const [branch, setbranch] = useState([]);
  const [staffId, Setstaffid] = useState([]);

  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [categoriescount, set_categoriescount] = useState([]);
  const [isBranchselectDisabled, setIsBranchDisabled] = useState(false);
  const [isStaffselectDisabled, setIsStaffDisabled] = useState(false);

  const [addData, setAddData] = useState({
    branch_id: "",
    staff_id: "",
    staff_name: "",
    date: "",
    Description: "",
    notes: "",
    status: "",
  });

  const [updateData, setUpdateData] = useState({
    branch_id: "",
    staff_id: "",
    staff_name: "",
    date: "",
    Description: "",
    notes: "",
    status: "",
    modified_date: "",
    modified_time: "",
  });

  useEffect(() => {
    fetchData();
    fetchDataed();
    gettoken();
    fetchDatastaff();
    getprevillages();
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //     window.scrollTo(0, 0);
  // }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      // Retrieve branch details and employee name from localStorage
      const branchId = localStorage.getItem("branch_id");
      const branchName = localStorage.getItem("branch_name");
      const empName = localStorage.getItem("username");

      // Check if the condition to fetch all data is met
      if (
        branchId === null ||
        branchName === "Branches" ||
        empName === undefined
      ) {
        // Fetch all attendance data if condition is true
        const response = await axios.get(apiUrl + "/dailytask");
        console.log(
          "Response from server with all attendance data:",
          response.data
        );
        setResponseData(response.data.reverse());

        if (response && response.status === 200) {
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }
      } else {
        // Fetch data based on branchId and empid (from localStorage)
        const response = await axios.get(apiUrl + "/dailytask", {
          params: { data: branchId },
        });
        console.log(
          "Response from server with filtered attendance data:",
          response.data
        );

        // Get the empid from localStorage
        const localEmpid = localStorage.getItem("username");

        // Filter data based on the empid from localStorage
        const filteredData = response.data.filter(
          (item) => item.staff_id === localEmpid
        );

        setResponseData(filteredData.reverse());
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  // const fetchData = async () => {
  //     try {
  //         const response = await axios.get(apiUrl + "/dailytask");
  //         console.log("Response from server:", response.data);
  //         setResponseData(response.data.reverse());
  //     } catch (error) {
  //         console.error("Error fetching data:", error.message);
  //     }
  // };

  const fetchDataed = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("Response from server:", response.data);
      const branchName = localStorage.getItem("branch_name");
      const branchid = localStorage.getItem("branch_id");

      if (branchName === 'Branches') {
        setbranch(response.data);
        console.log("ewhrwjkre211111", branch)
        // If branchName is 'Branches', set all branches
      } else {
        const filteredData = response.data.filter(branch => branch._id === branchid);
        setbranch(filteredData);
        console.log("ewhrwjkre222", branch)


        console.log("the console filteredItems", branch[0]?.branch_id)
        console.log("the console filteredItems", staffId)
        const filteredDatas = staffId.filter((staff) =>
          staff.branch_id.some((branch) => branch.branch_id.branch_id === branch[0]?.branch_id)

        );
        setfilterdata(filteredDatas)
        console.log("the console`1`1", filteredDatas)
        console.log("the console", filteredItems)





      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };










  const fetchDatastaff = async () => {
    try {
      const response = await axios.get(apiUrl + "/staff");
      console.log("Response from server staff:", response.data);
      Setstaffid(response.data);

      console.log("the response.data in the fetchDatastaff is : ", response.data);

    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };



  const gettoken = async () => {
    const token = localStorage.getItem("token");
    // console.log("the toekn in the localStorage is : ",token);
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      // setResponseData(response.data);

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      // getpages();

      if (id) {
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find(
      (item) => item.name == "Dailytask"
    );

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  // const handleNewButtonClick = () => {
  //     if (previllages.add || previllages.all) {
  //     setShowModal(true);
  // }else{
  //     toast.error("You don't have the permission to add");
  // }
  // }




  useEffect(() => {
    const branchId = localStorage.getItem("branch_id");
    if (branchId == "null") {
      console.log("The local storage branch_id is null : ");

      const fetch_overall_data = async () => {
        try {
          const response = await axios.get(apiUrl + "/status-count-overall");
          console.log("Response from server with status-count-overall data:", response.data);

          // set_categoriescount(response.data);

          const receivedData = response.data;

          // Define required categories
          const requiredCategories = ["Schedule", "Inprogress", "Completed", "Incompleted"];

          // Ensure all categories are present
          const updatedData = requiredCategories.map((status) => {
            const existingCategory = receivedData.find((item) => item.status === status);
            return existingCategory || { count: 0, status }; // If not found, add with count 0
          });

          set_categoriescount(updatedData);

        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      }

      fetch_overall_data();
    }
    else {
      const username = localStorage.getItem("username");

      if (username) {
        console.log("The local storage branch_id is null : ");

        const fetch_overall_data = async () => {
          try {
            const response = await axios.get(apiUrl + `/status-count-by-staff/${username}`);
            console.log("Response from server with status-count-overall data:", response.data.statuses);

            // set_categoriescount(response.data);

            const receivedData = response.data.statuses;

            // Define required categories
            const requiredCategories = ["Schedule", "Inprogress", "Completed", "Incompleted"];

            // Ensure all categories are present
            const updatedData = requiredCategories.map((status) => {
              const existingCategory = receivedData.find((item) => item.status === status);
              return existingCategory || { count: 0, status }; // If not found, add with count 0
            });

            set_categoriescount(updatedData);

          } catch (error) {
            console.error("Error fetching data:", error.message);
          }
        }

        fetch_overall_data();
      }
      else {
        alert("Something went wrong!")
      }
    }

    console.log("The useeffect function is called ", branchId == "null");
  }, []);
  // ============== code to show the categori count =========================



  const getStatusColor = (status) => {
    switch (status) {
      case "Schedule":
        return "#17a2b8"; // Example color
      case "Inprogress":
        return "#ffc107";
      case "Completed":
        return "#28a745";
      case "Incompleted":
        return "red";
      default:
        return "gray"; // Default color
    }
  };


  const handlesubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const formData = {
        branch_id: addData.branch_id,
        staff_id: addData.staff_id,
        staff_name: addData.staff_name,
        date: addData.date,
        Description: addData.Description,
        notes: addData.notes,
        status: addData.status,
        status: "Schedule",
      };
      const response = await axios.post(apiUrl + "/dailytask", formData);
      console.log("Updated:", response.data.date);
      setShowModal(false);
      toast.success("added successfully!");
      setAddData({
        branch_id: "",
        staff_id: "",
        staff_name: "",
        date: "",
        Description: "",
        notes: "",
        status: "",
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (_id, data) => {
    if (previllages.edit || previllages.all) {
      setUpdateId(_id);
      console.log(" the data to updata", data);
      setUpdateShowModal(true);
      const formattedDate = new Date(data.date).toISOString().split("T")[0];
      setUpdateData({
        branch_id: data.branch_id._id,
        staff_id: data.staff_id,
        staff_name: data.staff_name,
        date: formattedDate,
        Description: data.Description,
        notes: data.notes,
        status: data.status,
        modified_date: data.modified_date,
        modified_time: data.modified_time
      });
    } else {
      toast.error("You don't have the permission to update");
    }
  };

  const handlePreview = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to updata", data);
    setPreviewShowModal(true);
    const formattedDate = new Date(data.date).toISOString().split("T")[0];
    setUpdateData({
      branch_id: data.branch_id._id,
      staff_id: data.staff_id,
      staff_name: data.staff_name,
      date: formattedDate,
      Description: data.Description,
      notes: data.notes,
      status: data.status,

    });
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        branch_id: updateData.branch_id,
        staff_id: updateData.staff_id,
        staff_name: updateData.staff_name,
        date: updateData.date,
        Description: updateData.Description,
        notes: updateData.notes,
        status: updateData.status,
        modified_date: updateData.modified_date,
        modified_time: updateData.modified_time
      };
      console.log("the update submit data", formData);
      const response = await axios.put(
        apiUrl + `/dailytask/${updateid}`,
        formData
      );
      console.log("response for update", response.data.date);
      setUpdateShowModal(false);
      toast.success("Update successfully!");
      fetchData();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await axios.delete(apiUrl + `/dailytask/${getdeleteid}`);
      console.log("delete data ", response);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");

  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = (_id, staff_id) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the name", staff_id);
      setdeleteid(_id);
      setdeletename(staff_id);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission to delete");
    }
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Search
  const filtered = currentItems.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };
  // the pagination  end ---------------------------------------------------------------------

  // const createPagination = () => {
  //   let liTag = [];
  //   let beforePage = currentPage - 1;
  //   let afterPage = currentPage + 1;
  //   let active;

  //   if (currentPage > 1) {
  //     liTag.push(
  //       <li className="page-item" key="prev">
  //         <button
  //           className="page-link"
  //           onClick={() => paginate(currentPage - 1)}
  //         >
  //           <FaAngleLeft /> Prev
  //         </button>
  //       </li>
  //     );
  //   }

  //   if (currentPage > 2) {
  //     liTag.push(
  //       <li className="page-item" key="first" onClick={() => paginate(1)}>
  //         <button className="page-link">1</button>
  //       </li>
  //     );
  //     if (currentPage > 3) {
  //       liTag.push(
  //         <li className="page-item disabled" key="dots1">
  //           <span className="page-link">...</span>
  //         </li>
  //       );
  //     }
  //   }

  //   if (currentPage === totalPages) {
  //     beforePage -= 2;
  //   } else if (currentPage === totalPages - 1) {
  //     beforePage -= 1;
  //   }

  //   if (currentPage === 1) {
  //     afterPage += 2;
  //   } else if (currentPage === 2) {
  //     afterPage += 1;
  //   }

  //   for (let plength = beforePage; plength <= afterPage; plength++) {
  //     if (plength > totalPages || plength <= 0) continue;
  //     active = currentPage === plength ? "active" : "";
  //     liTag.push(
  //       <li
  //         className={`page-item ${active}`}
  //         key={plength}
  //         onClick={() => paginate(plength)}
  //       >
  //         <button className="page-link">{plength}</button>
  //       </li>
  //     );
  //   }

  //   if (currentPage < totalPages - 1) {
  //     if (currentPage < totalPages - 2) {
  //       liTag.push(
  //         <li className="page-item disabled" key="dots2">
  //           <span className="page-link">...</span>
  //         </li>
  //       );
  //     }
  //     liTag.push(
  //       <li
  //         className="page-item"
  //         key="last"
  //         onClick={() => paginate(totalPages)}
  //       >
  //         <button className="page-link">{totalPages}</button>
  //       </li>
  //     );
  //   }

  //   if (currentPage < totalPages) {
  //     liTag.push(
  //       <li className="page-item" key="next">
  //         <button
  //           className="page-link"
  //           onClick={() => paginate(currentPage + 1)}
  //         >
  //           Next <FaAngleRight />
  //         </button>
  //       </li>
  //     );
  //   }

  //   return liTag;
  // };

  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li
        className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
        key="prev"
      >
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 0 ? "active" : ""}`}
          key={0}
        >
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
          key={1}
        >
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 3, currentPage + 1);
      i++
    ) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 2 ? "active" : ""
            }`}
          key={totalPages - 2}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 2)}
          >
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 1 ? "active" : ""
            }`}
          key={totalPages - 1}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 1)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  // ======================================================
  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };

  useEffect(() => {
    // Get the current date
    const currentDate = new Date().toISOString().split("T")[0]; // Format to YYYY-MM-DD
    setAddData((prevData) => ({ ...prevData, date: currentDate }));
  }, []);

  useEffect(() => {
    // Get the current date
    const currentDate = new Date().toISOString().split("T")[0]; // Format to YYYY-MM-DD
    setUpdateData((prevData) => ({ ...prevData, date: currentDate }));
  }, []);


  useEffect(() => {
    getdataforselectstaff();
    fetchDatastaff();
  }, [])




  // const [filteredItems, setfilterdata] = useState([]);

  const handleBranch = (e) => {
    const selectedBranchId = e.target.value; // Selected branch ID
    setAddData({ ...addData, branch_id: selectedBranchId }); // Update state for branch_id
    setUpdateData({ ...updateData, branch_id: selectedBranchId }); // Update state for branch_id
    console.log("Selected Branch ID:", selectedBranchId);

    // Filter staff based on the selected branch
    const filteredData = staffId.filter((staff) =>
      staff.branch_id.some((branch) => branch._id === selectedBranchId)
    );
    setfilterdata(filteredData); // Update state with filte red staff
    console.log("Filtered Staff Data:", filteredData);

    console.log("Filtered staffId Data:", staffId);

  };

  const [filteredItems, setfilterdata] = useState([]);

  function handleAddClick() {
    // fetchDatastaff();
    getdataforselectstaff();

    console.log("the console filteredItems", branch[0]?.branch_id)
    console.log("the console filteredItems", staffId)
    // setShowModal(true);

    // code to set the dropdown
    const dropdown_branchcode = localStorage.getItem("branch_code");

    if (dropdown_branchcode != "All") {
      const dropdown_username = localStorage.getItem("username");
      const dropdown_name = localStorage.getItem("emp_name");
      const dropdown_branch_id = localStorage.getItem("branch_id");

      console.log("the dropdown_username is : ", dropdown_username)

      addData.branch_id = dropdown_branch_id;

      addData.staff_id = dropdown_username;
      addData.staff_name = dropdown_name;
      console.log("the addData.staff_id is : ", addData.staff_id)
      console.log("the addData.staff_name is : ", addData.staff_name)
      console.log("the filteredItems is : ", filteredItems)

      console.log("the staffId is : ", staffId);

      setIsBranchDisabled(true);
      setIsStaffDisabled(true);
    }

    setShowModal(true);
  }

  function getdataforselectstaff() {
    const dropdown_branch_id = localStorage.getItem("branch_id");

    const filteredData = staffId.filter((staff) =>
      // staff.branch_id.some((branch) => branch._id === selectedBranchId)
      staff.branch_id.some((branch) => branch._id === dropdown_branch_id)
    );

    console.log("the staffId is  : ", staffId);

    console.log("the filteredData in the getdataforselectstaff is : ", filteredData);

    setfilterdata(filteredData); // Update state with filtered staff
  }



  const handleEmpolye = (e) => {
    const selectedEmpId = e.target.value;
    const selectedEmpData = filteredItems.find((item) => item.empid === selectedEmpId);

    if (selectedEmpData) {
      setAddData({
        ...addData,
        staff_id: selectedEmpData.empid,
        staff_name: selectedEmpData.name, // Directly use staff name here
      });
    }
  };



  useEffect(() => {
    console.log(addData);
  }, [addData]);


  useEffect(() => {
    const branchId = localStorage.getItem("branch_id");
    if (branchId == "null") {
      console.log("The local storage branch_id is null : ");

      const fetch_overall_data = async () => {
        try {
          const response = await axios.get(apiUrl + "/status-count-overall");
          console.log("Response from server with status-count-overall data:", response.data);

          set_categoriescount(response.data);
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      }

      fetch_overall_data();
    }
    else {
      console.log("The local storage branch_id is not null : ");
    }

    console.log("The useeffect function is called ", branchId == "null");
  }, []);



  const [rolename, setrolename] = useState([]);
  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const [loading, setLoading] = useState(false);

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      branch_id: item.branch_id
        ? {
          _id: item.branch_id._id, // Check if branch_id exists and has _id
          branch_name: item.branch_id.branch_name, // Check if branch_id exists and has branch_name
        }
        : {

          _id: null,
          branch_name: null,
        },
      staff_id: item.staff_id,
      staff_name: item.staff_name,
      date: item.date,
      Description: item.Description,
      notes: item.notes,
      status: item.status,
      modified_date: item.modified_date
    }));
  }, [responseData]);






  const columns = useMemo(() => {
    const branchNameInLocalStorage = localStorage.getItem("branch_name"); // Get branch_name from localStorage

    return [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => {
          return row.index + 1;
        },
      },
      // Conditionally render the Branch column based on localStorage data
      branchNameInLocalStorage === "Branches" ? {
        Header: "Branch",
        accessor: "branch_id.branch_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        // Cell: ({ value }) => value?.branch_name || "N/A", // Fixed rendering issue
      } : null, // If the branch_name is not "Branches", do not show the column

      branchNameInLocalStorage === "Branches" ? {
        Header: "Staff Id",
        accessor: "staff_id",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      } : null,
      branchNameInLocalStorage === "Branches" ? {
        Header: "Staff Name",
        accessor: "staff_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      } : null,
      {
        Header: "Description",
        accessor: "Description",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          return (
            <span
              style={{
                display: "inline-block",
                width: "200px", // Set fixed width
              }}
            >
              {value}
            </span>
          );
        }
      },
      branchNameInLocalStorage === "Branches" ? {
        Header: "Notes",
        accessor: "notes",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",

      } : null,
      {
        Header: "Date",
        accessor: "date",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          const date = new Date(value); // Convert the ISO string to a Date object
          const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if necessary
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Get the month (zero-indexed, so add 1)
          const year = date.getFullYear();

          return `${day}-${month}-${year}`; // Return the formatted date
        },
      },
      {
        Header: "Modified Date",
        accessor: "modified_date",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          const date = new Date(value); // Convert the ISO string to a Date object
          const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if necessary
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Get the month (zero-indexed, so add 1)
          const year = date.getFullYear();

          return `${day}-${month}-${year}`; // Return the formatted date
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        width: 120,
        height: 10,
        Cell: ({ value }) => {
          const statusClass = getStatusLabelClass(value); // Get the class for the status

          return (
            <span
              className={`px-3 py-1 rounded-lg text-sm font-semibold ${statusClass}`} // Tailwind classes
              style={{
                display: "inline-block",
                width: "80px", // Set fixed width
                height: "20px", // Set fixed height
                lineHeight: "15px", // Center text vertically
                textAlign: "center", // Center align text horizontally
              }}
            >
              {value}
            </span>
          );
        },
      },
    ].filter(Boolean); // Remove null entries (i.e., when the branch column is not needed)
  }, []);




  // const columns = useMemo(
  //   () => [
  //     {
  //       Header: "S.No",
  //       id: "serialNo",
  //       Cell: ({ row }) => {
  //         return row.index + 1;
  //       },
  //     },
  //     {
  //       Header: "Branch",
  //       accessor: "branch_id.branch_name",
  //       Filter: DefaultColumnFilter,
  //       filter: "multiSelectFilter",
  //       // Cell: ({ value }) => value?.branch_name || "N/A", // Fixed rendering issue
  //     },
  //     {
  //       Header: "Staff Id",
  //       accessor: "staff_id",
  //       Filter: DefaultColumnFilter,
  //       filter: "multiSelectFilter",
  //     },
  //     {
  //       Header: "Staff Name",
  //       accessor: "staff_name",
  //       Filter: DefaultColumnFilter,
  //       filter: "multiSelectFilter",
  //     },
  //     {
  //       Header: "Description",
  //       accessor: "Description",
  //       Filter: DefaultColumnFilter,
  //       filter: "multiSelectFilter",
  //     },
  //     {
  //       Header: "Notes",
  //       accessor: "notes",
  //       Filter: DefaultColumnFilter,
  //       filter: "multiSelectFilter",
  //     },
  //     {
  //       Header: "Date",
  //       accessor: "date",
  //       Filter: DefaultColumnFilter,
  //       filter: "multiSelectFilter",
  //       Cell: ({ value }) => {
  //         const date = new Date(value); // Convert the ISO string to a Date object
  //         const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if necessary
  //         const month = String(date.getMonth() + 1).padStart(2, "0"); // Get the month (zero-indexed, so add 1)
  //         const year = date.getFullYear();

  //         return `${day}-${month}-${year}`; // Return the formatted date
  //       },
  //     },
  //     {
  //       Header: "Modified Date",
  //       accessor: "modified_date",
  //       Filter: DefaultColumnFilter,
  //       filter: "multiSelectFilter",
  //       Cell: ({ value }) => {
  //         const date = new Date(value); // Convert the ISO string to a Date object
  //         const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if necessary
  //         const month = String(date.getMonth() + 1).padStart(2, "0"); // Get the month (zero-indexed, so add 1)
  //         const year = date.getFullYear();

  //         return `${day}-${month}-${year}`; // Return the formatted date
  //       },
  //     },
  //     {
  //       Header: "Status",
  //       accessor: "status",
  //       Filter: DefaultColumnFilter,
  //       filter: "multiSelectFilter",
  //       width: 120,
  //       height: 10,
  //       Cell: ({ value }) => {
  //         const statusClass = getStatusLabelClass(value); // Get the class for the status

  //         return (
  //           <span
  //             className={`px-3 py-1 rounded-lg text-sm font-semibold ${statusClass}`} // Tailwind classes
  //             style={{
  //               display: "inline-block",
  //               width: "120px", // Set fixed width
  //               height: "20px", // Set fixed height
  //               lineHeight: "15px", // Center text vertically
  //               textAlign: "center", // Center align text horizontally
  //             }}
  //           >
  //             {value}
  //           </span>
  //         );
  //       },
  //     },
  //   ],
  //   []
  // );



  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const getStatusLabelClass = (status) => {
    switch (status) {
      case "Schedule":
        return "bg-info1 text-white1 ";
      case "Inprogress":
        return "bg-warning1 text-white1 ";
      case "Completed":
        return "bg-success1 text-white1 ";
      case "Incompleted":
        return "bg-danger1 text-white1 ";

      default:
        return "";
    }
  };





  const branchName = localStorage.getItem("branch_name");
  const username = localStorage.getItem("username");
  const empName = localStorage.getItem("emp_name");

  const isBranchDisabled = branchName !== "Branches";
  const isStaffDisabled = username && empName;




  const handleStatusChange = (e) => {
    const currentDateTime = new Date();
    const formattedDate = currentDateTime.toISOString().split("T")[0]; // Date in YYYY-MM-DD format
    const formattedTime = currentDateTime.toTimeString().split(" ")[0]; // Time in HH:MM:SS format

    // Update the status along with modified_date and modified_time
    setUpdateData({
      ...updateData,
      status: e.target.value,
      modified_date: formattedDate,
      modified_time: formattedTime,
    });
  };

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}



      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="/assetlist" className="text-secondary dashBoard_text">
                <b>Staff / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>DailyTask</b>
              </Link>
            </div>
          </div>
        </div>





        <div className="row">

          {/* <div className="d-flex"> */}



          <div className="col-lg-12 col-md-12 col-sm-12 " >
            <div
              className="card p-2"
              style={{
                // marginTop: "-80px",
                boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                marginBottom: "10px"
              }}
            >
              <div className="row">
                {categoriescount.map((item, index) => (
                  <div key={index} className="col-lg-3 col-md-6 col-sm-12">
                    <div className="card text-center border-3">
                      {/* <h6 className="bg-secondary text-white py-1">{item.status}</h6> */}
                      <h6 className="text-white py-1" style={{ backgroundColor: getStatusColor(item.status), color: "white" }}>{item.status}</h6>
                      <h3 className="">{item.count}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>







        {/* Table */}
        {/* <div className="d-flex">
          <h5 className="mt-2">Daily Task</h5>
          <div className="mx-3">
            {previllages.add && (
              // <button className="btn add" onClick={() => setShowModal(true)}>
              //   Add
              // </button>
              <button className="btn add" onClick={handleAddClick}>
                Add
              </button>
            )}
          </div>
        </div> */}

        {/* ------------ search and per page ----------------------------*/}

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1 d-flex">
              <div>
                <h5 className="mt-1">Daily Task</h5>
              </div>
              <div className="ms-3">
                {previllages.add && (

                  <button className="btn add" onClick={handleAddClick}>
                    Add
                  </button>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-between">

              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 ms-5 ps-3">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --------------------------------end------------------------------------------- */}
        {/* <div className='card'>
                    <div className="mt-1">
                        <table className="table table-striped">
                            <thead>
                                <tr>

                                    <th>S.No</th>
                                    <td> {rolename === "Branches" && <th>Branch</th>}</td>
                                    <th>Staff Id</th>
                                    <th>Staff Name</th>
                                    <th>Description</th>
                                    <th>Date</th>
                                    <th>Notes</th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{rolename === "Branches" && item.branch_id ? item.branch_id.branch_name : ""}</td>
                                        <td>{item.staff_id}</td>
                                        <td>{item.staff_name}</td>
                                        <td>{item.Description}</td>
                                        <td>{formatDatefitching(item.date)}</td>
                                        <td>{item.notes}</td>

                                        <td className='text-center'>
                                            {previllages.edit && (
                                                <button className='btn updelete mx-2' onClick={() => handleUpdate(item._id, item)}><i class="fa-solid fa-pen-to-square"></i></button>)}
                                            {previllages.delete && (<button className='btn delete'
                                                onClick={() => handleOpenModal(item._id, item.staff_id)}
                                            > <i class="fa-solid fa-trash-can"></i></button>)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div> */}

        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.staff_id)
                      }
                      onInfo={(id, row) =>
                        handlePreview(id, row)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        {/* Modal for adding a new user */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Daily Task</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <div className="floating-label">
                <select
                  className="form-select"
                  value={addData.branch_id}
                  onChange={handleBranch}
                  disabled={isBranchselectDisabled}
                >
                  <option value="">Select Branch</option>
                  {branch.map((item, index) => (
                    <option key={index} value={item._id}>
                      {item.branch_id} - {item.branch_name}
                    </option>
                  ))}
                </select>
                <label className={addData.branch_id ? "filled" : ""}>
                  Select Branch
                </label>
              </div>



              <div className="floating-label">
                <select
                  className="form-control"

                  value={addData.staff_id}
                  onChange={(e) => handleEmpolye(e)}
                  required
                  disabled={isStaffselectDisabled}
                >
                  <option value="" disabled>Select Staff Id</option>
                  {filteredItems.map((item, index) => (
                    <option key={index} value={item.empid}>
                      {item.empid} - {item.name}
                    </option>
                  ))}
                </select>
                <label className={addData.staff_id ? "filled" : ""}>
                  Select Staff Id
                </label>
              </div>


              {/* 
              <div className="floating-label">
                <select
                  className="form-control"

                  value={addData.staff_name}
                  onChange={(e) => handleEmpolye(e)}
                  required
                  disabled={isStaffselectDisabled}
                >
                  <option value="" disabled>Select Staff Name</option>
                  {filteredItems.map((item, index) => (
                    <option key={index} value={item.name}>
                      {item.empid} - {item.name}
                    </option>
                  ))}
                </select>
                <label className={addData.staff_name ? "filled" : ""}>
                  Select Staff Name
                </label>
              </div> */}




              <div className="floating-label">
                <input
                  className="form-control"
                  placeholder=""
                  type="date"
                  value={addData.date}
                  onChange={(e) =>
                    setAddData({ ...addData, date: e.target.value })
                  }
                  required
                />
                <label className={addData.date ? "filled" : ""}>Date</label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={addData.Description}
                  onChange={(e) =>
                    setAddData({ ...addData, Description: e.target.value })
                  }
                  required
                />
                <label className={addData.Description ? "filled" : ""}>
                  Description
                </label>
              </div>
              <div className="floating-label">
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={addData.notes}
                  onChange={(e) =>
                    setAddData({ ...addData, notes: e.target.value })
                  }
                  required
                />
                <label className={addData.notes ? "filled" : ""}>Notes</label>
              </div>

              {/* <div className="floating-label">
                <select
                  className="form-control"
                  value={addData.status}
                  onChange={(e) =>
                    setAddData({ ...addData, status: e.target.value })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Schedule">Schedule</option>
                  <option value="Inprogress">Inprogress</option>
                  <option value="Completed">Completed</option>
                  <option value="Incompleted">Incompleted</option>
                </select>
                <label className={addData.status ? "filled" : ""}>
                  Select Status
                </label>
              </div> */}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update DailyTask</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Other input fields */}

            <div className="form-group">
              <div className="floating-label">
                <select
                  className="form-select"
                  value={updateData.branch_id}
                  onChange={handleBranch}
                >
                  <option value="">Select Branch</option>
                  {branch.map((item, index) => (
                    <option key={index} value={item._id}>
                      {item.branch_id} - {item.branch_name}
                    </option>
                  ))}
                </select>
                <label className={updateData.branch_id ? "filled" : ""}>
                  Select Branch
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.staff_id}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, staff_id: e.target.value })
                  }
                  required
                  disabled
                />
                <label className={updateData.staff_id ? "filled" : ""}>
                  Staff Id
                </label>
              </div>

              {/* <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.staff_name}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, staff_name: e.target.value })
                  }
                  required
                  disabled
                />
                <label className={updateData.staff_name ? "filled" : ""}>
                  Staff Name
                </label>
              </div> */}

              <div className="floating-label">
                <input
                  className="form-control"
                  type="date"
                  placeholder=""
                  value={updateData.date}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, date: e.target.value })
                  }
                  required
                />
                <label className={updateData.date ? "filled" : ""}>Date</label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.Description}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      Description: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.Description ? "filled" : ""}>
                  Description
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  type="text"
                  placeholder=""
                  value={updateData.notes}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, notes: e.target.value })
                  }
                  required
                />
                <label className={updateData.notes ? "filled" : ""}>
                  Notes
                </label>
              </div>

              {/* <div className="floating-label">
                            <select className="form-control" value={updateData.status} onChange={(e) => setUpdateData({ ...updateData, status: e.target.value })}>
                                <option value="">Select Status</option>
                                <option value="Approved">Approved</option>
                                <option value="Pending">Pending</option>
                                <option value="Rejected">Rejected</option>
                            </select>
                            <label className={updateData.status ? "filled" : ""}>
                                Select Status
                            </label>
                        </div> */}

              <div className="floating-label">
                <select
                  className="form-control"
                  value={updateData.status}
                  onChange={handleStatusChange}
                // onChange={(e) =>
                //   setUpdateData({ ...updateData, status: e.target.value })
                // }
                >
                  <option value="">Select Status</option>
                  <option value="Inprogress">Inprogress</option>
                  <option value="Completed">Completed</option>
                  <option value="Incompleted">Incompleted</option>
                </select>
                <label className={updateData.status ? "filled" : ""}>
                  Select Status
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleupdatesubmit}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={isPreviewshowModal}
          onHide={() => setPreviewShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Preview DailyTask</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Other input fields */}

            <div className="form-group">
              <div className="floating-label">
                <select
                  className="form-select"
                  value={updateData.branch_id}
                  onChange={handleBranch}
                  disabled
                >
                  <option value="">Select Branch</option>
                  {branch.map((item, index) => (
                    <option key={index} value={item._id}>
                      {item.branch_id} - {item.branch_name}
                    </option>
                  ))}
                </select>
                <label className={updateData.branch_id ? "filled" : ""}>
                  Select Branch
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  disabled
                  type="text"
                  placeholder=""
                  value={updateData.staff_id}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, staff_id: e.target.value })
                  }
                  required
                />
                <label className={updateData.staff_id ? "filled" : ""}>
                  Staff Id
                </label>
              </div>

              {/* <div className="floating-label">
                <input
                  className="form-control"
                  disabled
                  type="text"
                  placeholder=""
                  value={updateData.staff_name}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, staff_name: e.target.value })
                  }
                  required
                />
                <label className={updateData.staff_name ? "filled" : ""}>
                  Staff Name
                </label>
              </div> */}

              <div className="floating-label">
                <input
                  className="form-control"
                  disabled
                  type="date"
                  placeholder=""
                  value={updateData.date}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, date: e.target.value })
                  }
                  required
                />
                <label className={updateData.date ? "filled" : ""}>Date</label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  disabled
                  type="text"
                  placeholder=""
                  value={updateData.Description}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      Description: e.target.value,
                    })
                  }
                  required
                />
                <label className={updateData.Description ? "filled" : ""}>
                  Description
                </label>
              </div>

              <div className="floating-label">
                <input
                  className="form-control"
                  disabled
                  type="text"
                  placeholder=""
                  value={updateData.notes}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, notes: e.target.value })
                  }
                  required
                />
                <label className={updateData.notes ? "filled" : ""}>
                  Notes
                </label>
              </div>

              {/* <div className="floating-label">
                    <select className="form-control" value={updateData.status} onChange={(e) => setUpdateData({ ...updateData, status: e.target.value })}>
                        <option value="">Select Status</option>
                        <option value="Approved">Approved</option>
                        <option value="Pending">Pending</option>
                        <option value="Rejected">Rejected</option>
                    </select>
                    <label className={updateData.status ? "filled" : ""}>
                        Select Status
                    </label>
                </div> */}

              <div className="floating-label">
                <select
                  className="form-control"
                  disabled
                  value={updateData.status}
                  onChange={(e) =>
                    setUpdateData({ ...updateData, status: e.target.value })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Schedule">Schedule</option>
                  <option value="Inprogress">Inprogress</option>
                  <option value="Completed">Completed</option>
                  <option value="Incompleted">Incompleted</option>
                </select>
                <label className={updateData.status ? "filled" : ""}>
                  Select Status
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setPreviewShowModal(false)}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ----------------delete */}

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1">Staff Id:</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
        {/* _------------------------------pagination button -------------------------------- */}

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {currentPage} of {totalPages}
              </span>
            </div>
            <div className="col-lg-5">
              <nav>
                <ul className="pagination justify-content-center">
                  {createPagination()}
                </ul>
              </nav>
            </div>
          </div>
        </div>

        {/* ---------------------------------------end ---------------------------------- */}
      </div>
    </>
  );
}

export default Dailytask;
